import React, { useCallback, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import { createMessage } from '../../utilities/utilities';
import Message from '../shared/Message';
import { addCity, allCities, oneCity, removeCity, updateCity } from '../../services/cities';
import { handleError } from '../../utilities/errorHandler';
import CustomLoader from '../shared/CustomLoader';
import CitiesTable from '../tables/CitiesTable';
import CityForm from '../forms/CityForm';

const Cities = () => {
    const [ isSaving, setIsSaving ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ city, setCity ] = useState(null);
    const [ cities, setCities ] = useState([]);

    const [ message, setMessage ] = useState({
        text: '',
        show: false,
        variant: ''
    });

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const getCities = useCallback( async () => {
        setIsLoading(true);

        try {
            const response = await allCities();
            if (response.status === 200){
                setCities(response.data);
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage) {
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getCities();
    }, [getCities]);

    const getCity = (id) => {
        oneCity(id).then((response) => {
            if (response.status === 200){
                setCity(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const deleteCity = (id) => {
        removeCity(id).then((response) => {
            if (response.status === 204) {
                handleMessage('City successfully deleted');
                getCities();
            }
        }).then(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const saveCity = async (data) => {
        setIsSaving(true);
        
        try {
            const cityData = {
                name: data.name
            };

            if (data.id){
                await updateCity(data.id, cityData);
                handleMessage('City successfully updated', 'success');
                getCities();
            } else {
                await addCity(cityData);
                handleMessage('City successfully saved', 'success');
                getCities();
            }

            return true;
        } catch (error) {
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e) {
                throw e; // error to be handled by onSubmit in CityForm
            }

            return false;
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }
  return (
    <Container fluid>

        <PageTitle title='City Details' />

        <Message
            message={message.text}
            variant={message.variant}
            show={message.show}
            handleClose={handleCloseMessage}
        />

        <CityForm
            city={city}
            isSaving={isSaving}
            formAction={saveCity}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <CitiesTable
                    cities={cities}
                    onDelete={deleteCity}
                    onEdit={getCity}
                />
            )
        }
    </Container>
  )
}

export default Cities